import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { ProGatePage } from "./billing/ProGate";

export default function ProtectedRoute({
  children,
  allowExpired = false,  // legacy prop — Free tier made it obsolete
  requirePro = false,
  proContext = "route",
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-zinc-950 text-zinc-400" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  // P0 2026-07-15 — Verification Wall: zentraler Guard, spiegelt das
  // Backend-Gate `require_verified_user` (Admin-Bypass identisch).
  if (user.email_verified === false && user.role !== "admin") {
    return <Navigate to="/verify-pending" state={{ email: user.email }} replace />;
  }
  // Phase 1 Public Discovery (2026-09) — die App-weite Paywall ist
  // Geschichte: Free-User behalten Feed, Favoriten (Limit), Detail,
  // Quelle. Nur explizit Pro-Flächen (Top Deals, AI) tragen
  // `requirePro` und zeigen den kontextuellen Gate mit Trial-CTA.
  if (requirePro && user.is_pro === false && user.role !== "admin") {
    return <ProGatePage surface="route" context={proContext} />;
  }
  return children;
}
